import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { useStyles } from './styles';
import SelectedBar from './selected-bar';
import FilterTable from './filter-table';
import { useClickAway } from 'common/hooks';

const NewSearch = props => {
  const NewSearchRef = useRef(null);

  const classes = useStyles();
  const {
    options,
    className,
    onChange,
    onSearch,
    defaultCheckedFilters,
    noSearch,
    placeholderInfo,
    prefixIcon,
    hasArrow,
    hasBorder,
    isMultiSelect,
    use,
    loading,
    customHeader,
    onScrollEnd,
  } = props;

  const [isShowFilterTable, setShowFilterTable] = useState(false);
  const [checkedFilters, setCheckedFilters] = useState(() => {
    if (defaultCheckedFilters) {
      return defaultCheckedFilters;
    }
    if (use === 'radioGroup') {
      return {};
    } else {
      return [];
    }
  });

  const handleHeaderClick = () => {
    setShowFilterTable(!isShowFilterTable);
  };

  useEffect(() => {
    setCheckedFilters(defaultCheckedFilters);
  }, [defaultCheckedFilters]);

  useClickAway(
    NewSearchRef,
    () => {
      setShowFilterTable(false);
    },
    ['mousedown'],
  );

  return (
    <div className={classNames(classes.searchBox, className)} ref={NewSearchRef}>
      <SelectedBar
        prefixIcon={prefixIcon}
        hasArrow={hasArrow}
        hasBorder={hasBorder}
        placeholderInfo={placeholderInfo}
        checkedFilters={use === 'radioGroup' ? Object.keys(checkedFilters) : checkedFilters}
        isShowFilterTable={isShowFilterTable}
        onClick={handleHeaderClick}
      />
      <FilterTable
        dataSource={options}
        checkedFilters={checkedFilters}
        setCheckedFilters={setCheckedFilters}
        isShowFilterTable={isShowFilterTable}
        setShowFilterTable={setShowFilterTable}
        noSearch={noSearch ? true : false}
        onChange={onChange}
        onSearch={onSearch}
        onScrollEnd={onScrollEnd}
        isMultiSelect={isMultiSelect}
        use={use}
        loading={loading}
        customHeader={customHeader}
      />
    </div>
  );
};

NewSearch.propTypes = {
  prefixIcon: PropTypes.string,
  noSearch: PropTypes.bool,
  hasArrow: PropTypes.bool,
  hasBorder: PropTypes.bool,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
    PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }),
        ),
      }),
    ),
  ]),
  onChange: PropTypes.func,
  defaultCheckedFilters: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholderInfo: PropTypes.object.isRequired,
  use: PropTypes.string,
};

export default NewSearch;
